// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_f7-0";
export var headerCellHover = "_f7-1";